import React from 'react';
import { Paper, Typography, Button } from '@mui/material';

// Gumroad 商品頁（pay-what-you-want）。點按鈕會帶上當前這集的 program_id，
// Gumroad 會把 URL 參數存進訂單，日後接 Gumroad Ping（webhook）即可自動對應要翻哪集。
const GUMROAD_PRODUCT = 'https://eys.gumroad.com/l/yezldu';

/**
 * 未翻譯集數的贊助 CTA。
 * 訪客請作者喝杯咖啡即可指定優先翻譯這一集；點按鈕連到 Gumroad 結帳頁，
 * 並帶上這一集的 program id 供事後對應／自動化。
 */
function SponsorTranslationCard({ program = {} }) {
  const { id, start_time = '', title = '' } = program || {};
  const dateStr = start_time.slice(0, 8);
  const prettyDate = dateStr.length === 8
    ? `${dateStr.slice(0, 4)}/${dateStr.slice(4, 6)}/${dateStr.slice(6, 8)}`
    : '';

  // wanted=true 直接開 Gumroad 原生購買流程；program_id 會進 webhook 的 url_params
  // （實測：原生購買會轉發自訂 URL 參數，自訂 landing 的 postMessage 買法則不會）。
  // 付款後 Gumroad Ping 帶著 url_params.program_id，即可自動觸發這一集的翻譯。
  const params = new URLSearchParams({ wanted: 'true' });
  if (id != null) params.set('program_id', String(id));
  const checkoutHref = `${GUMROAD_PRODUCT}?${params.toString()}`;

  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 2, p: 2.5,
        borderStyle: 'dashed',
        borderColor: 'primary.main',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        想看這集的中文翻譯嗎？
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        《{title}》{prettyDate && `（${prettyDate}）`}目前還沒有翻譯。
        請我喝杯咖啡，就能指定優先翻譯這一集——含中文字幕、日文逐字稿、繁中翻譯與 AI 摘要。
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href={checkoutHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        請我喝杯咖啡 · 指定這集
      </Button>
    </Paper>
  );
}

export default SponsorTranslationCard;
